import { useUploadImageComponent } from "@/erp/tecnico/orden-trabajo/shared/hooks";
import {
  newProspectoSchema, texto, calcularEdad,
  TipoIdentificacionEnumChoice, EstadoProspectoEnum,
  useUploadFile, BucketAwtENUM, EstadosContribuyenteRucENUM,
  useLoaders,
  EstadoSolicitudExtranjero, getEnvs,
  getSolicitudBeneficioLabel,
  matchSegmentEquifax,
} from "@/shared";
import { useCreateProspecto, useFetchGetPais, useFetchParametros, useFetchSearchIdentification } from "@/shared/actions/erp";
import { useFetchBuroCredito } from "@/shared/actions/erp/global/buro-crediticio";
import { fetchPostSolicitudDeuda } from "@/shared/actions/erp/solicitud_deuda/solicitud_deuda.actions";
import { getSolicitudExtranjero, usePostSolicitudExtranjero } from "@/shared/actions/erp/solicitud_extranjero/solicitud_extranjero.actions";
import { IFromProspecto, TipoDocumentoNameEnum, AlertSeverityEnum, RangoEdadEnum, NacionalidadEnum, IDataProspecto, CondicionCeduladoEnum, ProspectoTutorDescuento } from "@/shared/interfaces";
import { useSystemParamsStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { isAxiosError } from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { solicitudBeneficioProspectoEnum } from "../componente/SaveProspecto/SaveProspecto";
import dayjs from "dayjs";

const { VITE_NODE_ENV } = getEnvs()

export const valueDefaultForm = {
  tipo_identificacion: TipoDocumentoNameEnum.CEDULA,
  es_discapacitado: false,
  pais: NacionalidadEnum.CODIGO,
  nacionalidad: NacionalidadEnum.CODIGO,
  es_curador_tutor: false,
  es_bono_humano: false,
  reportado: false
}

interface IEsCliente { alerta: boolean; nombre: string; linea: number | undefined; plan: string }

export const useFormProspecto = () => {

  const {
    UploadImageComponent,
    fotoTutorDiscapacidad,
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante,
    setFotoDocumentoLegalRepresentante,
    fotoBonoDesarrolloHumano,
    setFotoBonoDesarrolloHumano,
  } = useUploadImageComponent();

  const { handleUploadFile } = useUploadFile();

  const navigate = useNavigate();

  //USESTATE
  const [disableIdentification, setDisableIdentification] = useState<boolean>(false)
  const [nombreRazonSocial,] = useState<string>('Nombre y Apellido')
  const [esCliente, setEsCliente] = useState<IEsCliente | null>(null)
  const [esDifunto, setEsDifunto] = useState<boolean>(false)
  const [esReportado, setEsReportado] = useState<boolean>(false)
  const [scoreBajo, setScoreBajo] = useState(false);

  const [esResidente, setEsResidente] = useState<boolean>(false)
  const [tutorDiscapacidad, setTutorDiscapacidad] = useState<boolean>(false)
  const [dataProspectoEnEspera, setDataProspectoEnEspera] = useState<IDataProspecto | null>(null)
  const [dataProspectoEnProceso, setDataProspectoEnProceso] = useState<IDataProspecto | null>(null)
  const [modalProspectoEnEspera, setModalProspectoEnEspera] = useState<boolean>(false)
  const [modalProspectoEnProceso, setModalProspectoEnProceso] = useState<boolean>(false)
  const [aplicaSolicitudBeneficio, setAplicaSolicitudBeneficio] = useState<boolean>(false)
  const [MotivoSolicitudBeneficio, setMotivoSolicitudBeneficio] = useState("NO_APLICA");
  const [maxBeneficios, setMaxBeneficios] = useState<boolean>(false)
  const valorMinEquifax = useSystemParamsStore(s => s.valorMinEquifax)
  const [fileIdentificacion, setFileIdentificacion] = useState<File | null>(null);
  const [fileCredencialEmpresa, setFileCredencialEmpresa] = useState<File | null>(null);
  const [fileDocLegalEmpresa, setFileDocLegalEmpresa] = useState<File | null>(null);
  const [dataSolicitudBeneficio, setDataSolicitudBeneficio] = useState<ProspectoTutorDescuento[]>([]);
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});
  //const [fileDocLegalEmpresa, setFileDocLegalEmpresa] = useState<File | null>(null);


  ///* store
  const setAlert = useUiStore((s) => s.setAlert);
  //setIsGlobalLoading = useUiStore((s) => s.//setIsGlobalLoading);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading)


  const schemaPreventaPymesSchema = useMemo(
    () => newProspectoSchema(valorRestriccionCel),
    [valorRestriccionCel]
  );
  ///* formulario
  const form = useForm<IFromProspecto>({
    resolver: yupResolver(schemaPreventaPymesSchema as any),
    defaultValues: valueDefaultForm
  });

  const {
    reset,
    control,
    setError,
    formState: { errors },
  } = form;

  const createProspectoMutation = useCreateProspecto({
    navigate
  });


  ///* react query
  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });
  const { data: dataPais, isLoading: isLoadingPais } = useFetchGetPais({
    estado: true,
    page_size: 100
  });
  const {
    mutateAsync: mutateAsyncBuroCredito,
    isPending: isPendingBuroCredito
  } = useFetchBuroCredito();

  const { mutateAsync: mutateAsyncSolicitudDeuda } = fetchPostSolicitudDeuda({})
  const {
    isPending: isPendingSearchIdentifaction,
    mutateAsync: searchDataByIdentification
  } = useFetchSearchIdentification({
    identificacion: form.watch().identificacion,
    enableSuccessAlert: false
  });

  const { mutateAsync: mutateAsyncSolicitudExtranjero } = usePostSolicitudExtranjero({
    enableAlert: true
  })

  useEffect(() => {
    reset({
      tipo_identificacion: TipoIdentificacionEnumChoice.CEDULA
    })
    setDisableIdentification(false);
  }, [])
  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {
      setValorRestriccionCel(
        dataParamRestriccionCel?.data?.data?.[0]?.valor 
        ? JSON.parse(dataParamRestriccionCel?.data?.data?.[0]?.valor) 
        : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])
  /**
   * 
   * Enviar formulario para crear un prospecto
   * 
   * @param data 
   * 
   * @returns 
   */
  const onSubmit = async (data: IFromProspecto) => {


    if ((scoreBajo || esReportado)
      && !form.getValues().observacion_solicitud) {
      toast.error('Ingresar motivo de solicitud.')
      setError('observacion_solicitud', {
        message: 'Campo obligatorio',
      })
      return
    }

    if (form.getValues().es_curador_tutor) {
      if (form.getValues().identificacion_carga_personal?.length! < 10) {
        setAlert(true, 'Digite la cédula de la persona con discapacidad correctamente.', AlertSeverityEnum.warning);
        return
      }

      if (!fotoTutorDiscapacidad
        || !fotoDocumentoLegalRepresentante) {
        setAlert(
          true,
          'Faltan fotos por cargar',
          AlertSeverityEnum.error
        );
        return;
      }

      await handleUploadImagesFamiliarDiscapacidad(data);
    }

    if (form.getValues().es_gremio) {

      if (!fileIdentificacion
        || !fileCredencialEmpresa
        //|| !fileDocLegalEmpresa
      ) {
        setAlert(
          true,
          'Documentos faltantes.',
          AlertSeverityEnum.error
        );
        return;
      }

      await handleUploadImageGremio(data);
    }

    if (form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC
      && form.getValues().estado_contribuyente_ruc == EstadosContribuyenteRucENUM.SUSPENDIDO)
      return setAlert(true, 'Estado contribuyente suspendido', 'error');

    //setIsGlobalLoading(true);

    if (!form.getValues().residencia_permanente) {
      //setIsGlobalLoading(false);
      setAlert(true, texto.sin_condicion_residencia, AlertSeverityEnum.info);
      return
    }

    if (form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA) {
      let edad = calcularEdad(data.fecha_nacimiento!);
      if (edad < 18) {
        //setIsGlobalLoading(false);
        setAlert(true, texto.edad_no_permitida, AlertSeverityEnum.warning);
        return;
      }
      data.es_tercera_edad = edad >= RangoEdadEnum.EDAD_MAXIMA && !maxBeneficios;
    } else {
      data.edad = RangoEdadEnum.EDAD_MINIMA;
    }


    if (data.es_curador_tutor
      || data.es_bono_humano
      || data.es_ayuda_social
      || data.es_reportado
      || data.reportado
    ) {

      data.observaciones = {
        observacion_solicitud: data.observacion_solicitud
      }

      setConfirmDialog({
        isOpen: true,
        title: 'Solicitud de Ingreso',
        subtitle:
          `Para acceder al beneficio "${getSolicitudBeneficioLabel({
            es_bono_humano: data.es_bono_humano,
            es_gremio: data.es_gremio,
            es_reportado: data.es_reportado,
            reportado: data.reportado,
            es_tutor: data.es_curador_tutor,
            es_ayuda_social: data.es_ayuda_social
          })}" se debe crear la solicitud de revisión del ingreso. Al dar clic en continuar se generará la solicitud automáticamente.`,
        onClose() {

          setConfirmDialogIsOpen(false)

        },
        async onConfirm() {
          setConfirmDialogIsOpen(false)
          setIsGlobalLoading(true)


          await createProspectoMutation.mutateAsync(data);
          return
        },
        cancelTextBtn: 'Cerrar',
        confirmTextBtn: 'Continuar'
      });

      return;
    }

    await createProspectoMutation.mutateAsync(data);

    //setIsGlobalLoading(false);

  }

  /**
   * Busca información de la persona por cédula y valida si tiene discapacidad 
   * emitiendo alertas en caso de que la persona tenga valores pendientes
   * @param identificacion cédula
   * @returns 
   */


  const fnBuscarIdentificacionDiscapacidad = async (identificacion: string) => {
    try {


      const e = await searchDataByIdentification({ identificacion, verificar_cliente: true })
      const data = e.data

      if (e.code === 202) {

        let dataDeuda = {
          valorPendiente: 0.00,
          concepto: ''
        }
        if (data.deudas != null) {
          dataDeuda = {
            valorPendiente: Number.parseFloat(data.deudas.at(0)?.pendientePorCobrar ?? '0'),
            concepto: data.deudas?.at(0)?.concepto ?? 'PAGO',
          }
        }

        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: '¡Valores pendientes!',
          subtitle: `El cliente tiene un deuda pendiente de "$${dataDeuda.valorPendiente.toFixed(2)}" bajo el concepto de "${dataDeuda.valorPendiente}". ¿Deseas enviar la solicitud al supervisor para aprobar el ingreso con deuda?`,
          confirmTextBtn: 'Confirmar',
          onClose() {
            setConfirmDialogIsOpen(false);
          },
          async onConfirm() {
            await mutateAsyncSolicitudDeuda({
              identificacion,
              deuda: dataDeuda.valorPendiente.toFixed(2),
              razon_social: data.razon_social ?? data.razonSocial,
            })
          },
          cancelTextBtn: 'Cerrar',
        })

        return
      }

      if (e.code === 201) {
        let planeC = data.planes != null ? data.planes.map(e => e.nombre).join('\n') : 'N/A';
        setEsCliente({ alerta: true, linea: e.linea, nombre: data.razon_social, plan: planeC });
        console.log(data);
        setDataSolicitudBeneficio(data.prospectos_tutor_descuento ?? []);
      } else {
        setEsCliente(null);
      }

      form.setValue('linea', e.linea)

      //setIsGlobalLoading(true);

      if (identificacion.length === 10) {
        if (data.discapacidad || data.es_discapacitado || data.condicionCedulado?.includes(CondicionCeduladoEnum.INTERDICTO)) {
          data.es_discapacitado && setAlert(true, texto.persona_con_discapacidad, 'info');
          if (form.getValues().es_curador_tutor) {
            setTutorDiscapacidad(true)
            reset({
              ...form.getValues(),
              es_discapacitado: false,
              //beneficio tutor discapacidad
              es_curador_tutor: true,
              identificacion_carga_personal: identificacion,
              razon_social_carga_personal: data.razon_social,
            })
          }
        } else {
          setTutorDiscapacidad(false)
          reset({
            ...form.getValues(),
            es_discapacitado: false,
            //beneficio tutor discapacidad
            es_curador_tutor: false,
            identificacion_carga_personal: "",
            razon_social_carga_personal: "",
          })
          !data.es_discapacitado && setAlert(true, texto.persona_sin_discapacidad, 'info');
        }
      }

    } catch (error) {

      //handleAxiosError(error)

      if (isAxiosError(error)) {

        const respError: any = error.response?.data || {};

        if (respError === 408) return setEsDifunto(true);

        if (respError.code == 407
          || respError.code == 406
          || respError.code == 500
          || error.code == 'ERR_NETWORK'
          || error.code == 'ERR_BAD_RESPONSE') {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Problemas al consultar en Registro Civil!',
            subtitle: `Los servicios de consulta no están disponibles en este momento.`,
            confirmTextBtn: 'Confirmar',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            async onConfirm() {
              setConfirmDialogIsOpen(false);
            },
            cancelTextBtn: 'Cerrar',
          });
          return;
        }

        // if (respError?.code == 409) {

        //   const dataProspectos = respError?.data as IDataProspecto[];

        //   for (const element of dataProspectos) {
        //     if (element.estado_prospecto == EstadoProspectoEnum.EN_ESPERA) {
        //       setDataProspectoEnEspera(element);
        //       setModalProspectoEnEspera(true);
        //       return;
        //     }

        //     if (element.estado_prospecto == EstadoProspectoEnum.EN_PROCESO) {
        //       setDataProspectoEnProceso(element);
        //       setModalProspectoEnProceso(true);
        //       return;
        //     }
        //   }
        // }



      } else {
        //handleAxiosError(error)
      }

    } finally {
      //setIsGlobalLoading(false);

    }
  }





  function contarPorPropiedad(arr: any[], propiedad: string, propiedad2: string): number {
    return arr.filter((item) => item[propiedad] === true || item[propiedad2] === true).length;
  }


  /**
   * Funcion fnBuscarIdentificacion
   * 
   * Realiza una búsqueda asincrónica para obtener información basada en un número de identificación
   * 
   * 202 - Valores pendientes
   * 201 - Es cliente de fibramax
   * 
  */
  const fnBuscarIdentificacion = async (identificacion: string) => {

    try {

      reset({})
      setMotivoSolicitudBeneficio("NO_APLICA");

      let excede = false;

      const respRegistroCivil = await searchDataByIdentification({ identificacion, verificar_cliente: true })
      const data = respRegistroCivil.data


      ///* Tiene dedudas pendientes por pagar
      if (respRegistroCivil.code == 202) {

        let dataDeuda = {
          valorPendiente: 0.00,
          concepto: ''
        }

        if (data.deudas != null) {
          dataDeuda = {
            valorPendiente: Number.parseFloat(data.deudas.at(0)?.pendientePorCobrar ?? '0'),
            concepto: data.deudas?.at(0)?.concepto ?? 'PAGO',
          }
        }

        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: '¡Valores pendientes!',
          subtitle: `El cliente tiene un deuda pendiente de "$${dataDeuda.valorPendiente.toFixed(2)}" bajo el concepto de "${dataDeuda.valorPendiente}". ¿Deseas enviar la solicitud al supervisor para aprobar el ingreso con deuda?`,
          confirmTextBtn: 'Confirmar',
          onClose() {
            setConfirmDialogIsOpen(false);
          },
          async onConfirm() {
            await mutateAsyncSolicitudDeuda({
              identificacion,
              deuda: dataDeuda.valorPendiente.toFixed(2),
              razon_social: data.razon_social ?? data.razonSocial,
            })

            setConfirmDialogIsOpen(false);

          },
          cancelTextBtn: 'Cerrar',
        })

        return
      }

      ///* calcular edad
      let dataEdad = data.edad;

      if (dataEdad == null) {
        const edad = calcularEdad(data.fecha_nacimiento);
        form.setValue('edad', edad)
        dataEdad = edad;
      }

      if (dataEdad < RangoEdadEnum.EDAD_MINIMA
        && form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA) {
        return setAlert(true, texto.edad_no_permitida, AlertSeverityEnum.warning);
      }

      if (data.condicionCedulado?.includes(CondicionCeduladoEnum.PERDIDA_DE_DERECHOS)) {
        return setAlert(true, texto.derechos_perdidos, AlertSeverityEnum.warning);
      }

      if (data.fecha_nacimiento == null) {
        form.setValue('fecha_nacimiento', dayjs().format('YYYY-MM-DD'))
      }

      ///* Es cliente de Fibramax
      if (respRegistroCivil.code === 201) {
        let planeC = data.planes != null
          ? data.planes.map(plan => `-${plan.nombre}`).join('\n')
          : 'N/A';
        setEsCliente({ alerta: true, linea: data.lineas, nombre: data.razon_social, plan: planeC });

        ///* planes solo se pueden aplicar una vez
        const validarPlan = data.planes.some(e => e.es_ayuda_social
          || e.es_bono_humano
          || e.es_curador_tutor);

        if (validarPlan) {
          setAplicaSolicitudBeneficio(false)
        }

        ///* Validar plan beneficio maximo 3 entre discapacidad y tercera edad, 1 plan de ayuda social y bono de desarollo

        const planCliente = data.planes;
        const contBenMayorDisc = contarPorPropiedad(planCliente, "es_tercera_edad", "es_discapacidad") // plan para tercerad edad y discapacitado

        excede = contBenMayorDisc >= 3;


        if (excede) {
          reset({
            ...form.getValues(),
            es_discapacitado: false,
            es_tercera_edad: false,
          })
          console.log('cliente tiene  de beneficios', contBenMayorDisc);
          toast.info("Cliente excedio el máximo de beneficio para tercera edad y discapacidad.")
          setMaxBeneficios(true)

        } else {
          excede = false
          reset({
            ...form.getValues(),
            es_discapacitado: data.es_discapacitado ?? false,
            es_tercera_edad: data.es_tercera_edad ?? false,
          })
        }

        setDataSolicitudBeneficio(data.prospectos_tutor_descuento ?? []);


      } else {
        setEsCliente(null);
      }

      ///* registro INTERDICTO
      if (data.condicionCedulado?.includes(CondicionCeduladoEnum.INTERDICTO)) {
        return setAlert(true, 'La condición del cedulado no le permite la firma de contratos sin un tutor/curador.', AlertSeverityEnum.info);
      }

      form.setValue('linea', respRegistroCivil.linea);

      const paisInfo = dataPais?.data.data.find(e => e.nacionalidad == data.nacionalidad);

      //setIsGlobalLoading(true);

      ///* Cliente con residencia temporal
      ///* Temporal Visado
      const isVisado = [
        CondicionCeduladoEnum.VISADO,
        CondicionCeduladoEnum.TEMPORAL
      ].some(cond => data.condicionCedulado?.includes(cond));


      if (isVisado) {

        const resp = await getSolicitudExtranjero({
          identificacion
        })

        const estadoSolicitud = resp.data.data.at(0)?.estado_solicitud

        if (estadoSolicitud == EstadoSolicitudExtranjero.APROBADO) {
          setAplicaSolicitudBeneficio(false)
          form.setValue('residencia_permanente', true)
          setEsResidente(true);
          setAlert(true, `Solicitud ${EstadoSolicitudExtranjero.APROBADO} para la venta de un cliente con residencia de extranjero temporal.`, AlertSeverityEnum.success)
        }

        if (estadoSolicitud != EstadoSolicitudExtranjero.APROBADO) {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Persona con residencia TEMPORAL!',
            subtitle: texto.solicitud_extranjero,
            confirmTextBtn: 'Confirmar',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            async onConfirm() {

              await mutateAsyncSolicitudExtranjero({
                estado_solicitud: EstadoSolicitudExtranjero.EN_ESPERA,
                identificacion
              })

              setConfirmDialogIsOpen(false);

            },
            cancelTextBtn: 'Cerrar',
          });
          return
        }

      }

      form.setValue('residencia_permanente', true)

      // validar si el prospecto tiene solicitudes de beneficio
      setDataSolicitudBeneficio(data.prospectos_tutor_descuento ?? []);

      ///* venta con cedula
      if (identificacion.length === 10) {

        reset({
          ...form.getValues(),
          fecha_nacimiento: data.fecha_nacimiento,
          razon_social: data.razon_social,
          edad: dataEdad,
          nacionalidad: paisInfo?.codigo || '',
          pais: paisInfo?.codigo || ''
        })

        dataEdad >= RangoEdadEnum.EDAD_MAXIMA && setAlert(true, texto.persona_tercera_edad, 'info');

        if (!excede) {

          if (data.discapacidad || data.es_discapacitado
            || data.condicionCedulado?.includes(CondicionCeduladoEnum.DISCAPACIDAD)
            || data.condicionCedulado?.includes(CondicionCeduladoEnum.DISCAPACITADO)
          ) {
            setAplicaSolicitudBeneficio(false)
            data.es_discapacitado && setAlert(true, texto.persona_con_discapacidad, 'info')
            form.setValue("es_discapacitado", true)
          }
        }
      }

      if (identificacion.length === 13) {
        form.setValue('residencia_permanente', true)

        reset({
          ...form.getValues(),
          nacionalidad: NacionalidadEnum.CODIGO,
          pais: NacionalidadEnum.CODIGO,
          razon_social: data.razonSocial,
          tipo_contribuyente: data.tipoContribuyente || data.tipo_contribuyente,
          estado_contribuyente_ruc: data.estadoContribuyenteRuc,
          regimen: data.regimen,
          actividad_economica_principal: data.actividadEconomicaPrincipal
        })
      }

      const resp = await mutateAsyncBuroCredito({
        identificacion
      });

      const equifax = resp.data;

      const scoreBajo = equifax.puntaje_score_empresa < valorMinEquifax?.score_empresa!
        && matchSegmentEquifax(valorMinEquifax?.segmentacion!, equifax.segmentacion);

      reset({
        ...form.getValues(),
        segmentacion: equifax.segmentacion,
        puntaje_score_empresa: equifax.puntaje_score_empresa,
        puntaje_score: equifax.puntaje_score,
        puntaje_score_sobreendeudamiento: equifax.puntaje_score_sobreendeudamiento,
        reportado: equifax.reportado,
        es_reportado: scoreBajo
      })

      setScoreBajo(scoreBajo ?? false)
      setEsReportado(equifax.reportado ?? false)

    } catch (error) {

      if (isAxiosError(error)) {

        const respError: any = error.response?.data || {};

        if (respError.code == 408) return setEsDifunto(true)

        if (respError.code == 407
          || respError.code == 406
          || respError.code == 500
          || error.code == 'ERR_NETWORK'
          || error.code == 'ERR_BAD_RESPONSE') {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Problemas al consultar en Registro Civil!',
            subtitle: `Los servicios de consulta no están disponibles en este momento. Mientras tanto, puedes ingresar los datos manualmente.`,
            confirmTextBtn: 'Confirmar',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            async onConfirm() {

              const respBuroCredio = await mutateAsyncBuroCredito({
                identificacion
              });

              reset({
                ...form.getValues(),
                segmentacion: respBuroCredio.data.segmentacion,
                puntaje_score_empresa: respBuroCredio.data.puntaje_score_empresa,
                puntaje_score: respBuroCredio.data.puntaje_score,
                puntaje_score_sobreendeudamiento: respBuroCredio.data.puntaje_score_sobreendeudamiento,
                reportado: respBuroCredio.data.reportado,
                nacionalidad: NacionalidadEnum.CODIGO,
                pais: NacionalidadEnum.CODIGO,
              })

              setConfirmDialogIsOpen(false);
              setEsResidente(true);
              setEsReportado(respBuroCredio.data.reportado);
              form.setValue('residencia_permanente', true)
              //setcheckedResidencia(true);
            },
            cancelTextBtn: 'Cerrar',
          });
          return;
        }

        ///* Tiene una venta en proceso
        if (respError?.code == 409) {

          const dataProspectos = respError?.data as IDataProspecto[];

          for (const element of dataProspectos) {
            if (element.estado_prospecto == EstadoProspectoEnum.EN_ESPERA) {
              setDataProspectoEnEspera(element);
              setModalProspectoEnEspera(true);
              return;
            }

            if (element.estado_prospecto == EstadoProspectoEnum.EN_PROCESO) {
              setDataProspectoEnProceso(element);
              setModalProspectoEnProceso(true);
              return;
            }
          }
        }


      } else {
        //handleAxiosError(error)
      }

    } finally {
      //setIsGlobalLoading(false);

    }
  }





  //CARGA DE IMAGENES
  const handleUploadImagesFamiliarDiscapacidad = async (data: IFromProspecto) => {
    ///* validations
    if (
      !fotoTutorDiscapacidad &&
      !fotoDocumentoLegalRepresentante
    ) {
      setAlert(
        true,
        'Faltan fotos por cargar',
        AlertSeverityEnum.error
      );
      return;
    }

    //setIsGlobalLoading(true);
    const [
      fotoTutorDiscapacidadRes,
      fotoDocumentoLegalRepresentanteRes,
    ] = await Promise.all([
      handleUploadFile(fotoTutorDiscapacidad!, BucketAwtENUM.IMAGE_SOLICITUD_BENEFICIO_TUTOR),
      handleUploadFile(fotoDocumentoLegalRepresentante!, BucketAwtENUM.IMAGE_SOLICITUD_BENEFICIO_TUTOR),
    ]);

    data.url_foto_tutor_discapacidad = fotoTutorDiscapacidadRes?.url
    data.url_foto_documento_legal_representante = fotoDocumentoLegalRepresentanteRes?.url
    data.es_curador_tutor = true
    data.es_bono_humano = false
  };

  const handleUploadImageGremio = async (data: IFromProspecto) => {
    ///* validations
    if (
      !fileIdentificacion &&
      !fileCredencialEmpresa
      //&&! fileDocLegalEmpresa
    ) {
      setAlert(
        true,
        'Documentos faltantes.',
        AlertSeverityEnum.error
      );
      return;
    }

    //setIsGlobalLoading(true);
    const [
      urlIdentificacion,
      urlCredencialEmpresa,
      //urlDocLegalEmpresa
    ] = await Promise.all([
      handleUploadFile(fileIdentificacion!, BucketAwtENUM.IMAGE_SOLICITUD_BENEFICIO_TUTOR),
      handleUploadFile(fileCredencialEmpresa!, BucketAwtENUM.IMAGE_SOLICITUD_BENEFICIO_TUTOR),
      //handleUploadFile(fileDocLegalEmpresa!, BucketAwtENUM.IMAGE_SOLICITUD_BENEFICIO_TUTOR),
    ]);

    data.url_foto_identificacion_personal_gremio = urlIdentificacion?.url
    data.url_foto_credencial_empresa = urlCredencialEmpresa?.url
    //data.url_foto_documento_legal_empresa = urlDocLegalEmpresa?.url
  };

  function onChangeBeneficio(data: string) {

    setMotivoSolicitudBeneficio(data)
    reset({
      ...form.getValues(),
      es_reportado: false,
      es_curador_tutor: data == solicitudBeneficioProspectoEnum.FAMILIAR_CON_DISCAPACIDAD,
      es_bono_humano: data == solicitudBeneficioProspectoEnum.USUARIO_DE_BONO_DESARROLLO_HUMANO,
      es_ayuda_social: data == solicitudBeneficioProspectoEnum.AYUDA_SOCIAL
    });

    if (data == solicitudBeneficioProspectoEnum.NO_APLICA) {
      form.setValue('es_reportado', +(form.getValues()?.puntaje_score_empresa ?? 0) <= valorMinEquifax?.score_empresa!)
    }


  }

  const handleBuscarIdentificacion = (aux: string) => {

    setEsReportado(false)
    setScoreBajo(false)
    setEsDifunto(false)
    setEsResidente(false)
    setAplicaSolicitudBeneficio(true)
    setEsCliente(null)
    setDataSolicitudBeneficio([])

    if (aux) {
      switch (form.getValues().tipo_identificacion) {
        case TipoDocumentoNameEnum.CEDULA:
          if (aux?.length == 10) {
            //const isValid = validateEcuadorianID(form.getValues().identificacion);
            //if (!isValid) return setAlert(true, 'La cédula que ingreso no es valida', AlertSeverityEnum.warning);
            reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
            //setIsGlobalLoading(true);
            fnBuscarIdentificacion(aux);
            return;
          }
          reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
          /* setEsCliente(null);
          setScoreBajo(false)
          setEsReportado(false) */
          break;

        case TipoDocumentoNameEnum.RUC:
          if (aux?.length == 13) {
            reset({ ...form.getValues(), identificacion: aux });
            //setIsGlobalLoading(true);
            fnBuscarIdentificacion(aux);
            return;
          }
          reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
          //setEsCliente(null);

          break;
        default:
          reset({ tipo_identificacion: form.getValues().tipo_identificacion })
          setEsResidente(false);
          form.setValue('residencia_permanente', false)
          //setcheckedResidencia(true);
          break;
      }
      return;
    }

    reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: '', residencia_permanente: false, })
  }


  const handleFamiliarConDiscapacidad = (aux: string) => {
    setEsDifunto(false);
    setEsCliente(null)
    if (aux) {
      if (aux?.length == 10) {
        reset({
          ...form.getValues(),
          tipo_identificacion_beneficio: form.getValues().tipo_identificacion_beneficio,
          identificacion_carga_personal: aux,
        });
        //setIsGlobalLoading(true);
        fnBuscarIdentificacionDiscapacidad(aux);
        return;
      }
      reset({
        ...form.getValues(), tipo_identificacion_beneficio: form.getValues().tipo_identificacion_beneficio,
        identificacion_carga_personal: aux,

      });
      setEsCliente(null);

      return;
    }
    reset({ ...form.getValues(), tipo_identificacion_beneficio: form.getValues().tipo_identificacion_beneficio, identificacion_carga_personal: '' })

  }

  const cleanProspecto = () => {
    reset(valueDefaultForm);
    setDataSolicitudBeneficio([]);
    setDataProspectoEnProceso(null);
    setDataProspectoEnEspera(null);
    setDisableIdentification(false);
    setEsCliente(null);
    setEsDifunto(false);
    setEsReportado(false);
    setScoreBajo(false);
    setEsResidente(false);
  }

  useLoaders(
    isPendingSearchIdentifaction ||
    isPendingBuroCredito
  );

  return {

    //state
    esDifunto,
    setEsDifunto,
    esCliente,
    setEsCliente,
    tutorDiscapacidad,
    esReportado,
    setEsReportado,

    setDisableIdentification,
    disableIdentification,
    setAlert,
    //setIsGlobalLoading,
    setEsResidente,
    nombreRazonSocial,
    esResidente,
    isLoadingPais,
    dataPais: dataPais?.data.data,

    dataProspectoEnEspera,
    setModalProspectoEnEspera,
    modalProspectoEnEspera,
    dataProspectoEnProceso,
    setModalProspectoEnProceso,
    modalProspectoEnProceso,

    scoreBajo,
    setScoreBajo,
    onChangeBeneficio,

    //form
    form,
    control,
    reset,
    errors,
    setError,

    //fn
    onSubmit,
    fnBuscarIdentificacion,
    fnBuscarIdentificacionDiscapacidad,

    ///*Carga de imagenes para beneficio
    UploadImageComponent,
    fotoTutorDiscapacidad,
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante,
    setFotoDocumentoLegalRepresentante,
    fotoBonoDesarrolloHumano,
    setFotoBonoDesarrolloHumano,
    handleFamiliarConDiscapacidad,
    MotivoSolicitudBeneficio,
    setMotivoSolicitudBeneficio,
    ///*
    aplicaSolicitudBeneficio,
    setAplicaSolicitudBeneficio,
    handleBuscarIdentificacion,

    fileIdentificacion, setFileIdentificacion,
    fileCredencialEmpresa, setFileCredencialEmpresa,
    fileDocLegalEmpresa, setFileDocLegalEmpresa,
    cleanProspecto,
    dataSolicitudBeneficio,
    valorRestriccionCel,
    //fileDocLegalEmpresa, setFileDocLegalEmpresa,
  }
}
